export default __webpack_public_path__ + "static/media/small_foster.3bb38355.png";